import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBSection extends Mixins(SBComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    public color!: string;

    @Prop({
        type: String,
        default: "Medium",
    })
    public size!: "Medium" | "Large" | "Small" | "Form";

}
